import { FC, useState } from "react";
import { Projeto } from "../types";
import { Button, Dialog, DialogActions, DialogContent } from "@mui/material";
import api, { IDataRequest } from "src/framework/providers/api";

export interface ProjetoPrioridadeDom extends Pick<Projeto, "id"> {
    projetoID?: number;
}

export interface ProjetosModalProps {
    codigo_venda: string ;
    projetoId: number;
    open: boolean;
    setOpen: (value: boolean) => void;
    mostrarValores?: boolean;
    tipo?: string,
    url: string,
}

const ModalPropostas: FC<ProjetosModalProps> = ({ 
    projetoId,
    open,
    setOpen,
    mostrarValores,
    codigo_venda,
    tipo,
    url,
}) => {
    
    return (
        <Dialog
            key="projetos-prioridade-modal"
            open={open}
            onClose={setOpen}
            aria-labelledby="form-dialog-title"
            title={"Proposta"}
            maxWidth="xl"
            >
            <DialogContent style={{ height: "80vh", width: "90vw", overflow: 'hidden'}}>
               <object aria-label="pdf proposta" data={url} type="application/pdf" style={{width: "100%", height: "100%"}}/>
            </DialogContent>
            <DialogActions style={{alignItems: 'left', marginRight: "15px"}}>
                <Button
                    onClick={() => {
                        setOpen(false);
                    }}
                    color="secondary"
                    variant="outlined"
                    >
                    Fechar
                </Button>
                
                <Button color="primary" variant="contained" disableElevation>
                    <a style={{ textDecoration: 'none', color: 'white' }} href={url} download={`Proposta_${codigo_venda}`}>Baixar</a>
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export { ModalPropostas }